import {Reducer} from 'redux';
import {HIDE_LOADER, LoaderActionTypes, LoaderState, SHOW_LOADER} from '../action/loaderAction';

export const initialLoaderState = {
    waitCount: 0,
    show: false
};

const loaderReducer: Reducer<LoaderState, LoaderActionTypes> = (state = initialLoaderState, action) => {
    switch (action.type) {
        case SHOW_LOADER: {
            const newWaitCount = state.waitCount + 1;
            return {
                waitCount: newWaitCount,
                show: newWaitCount > 0
            };
        }

        case HIDE_LOADER: {
            const newWaitCount = state.waitCount - 1;
            return {
                waitCount: newWaitCount >= 0 ? newWaitCount : 0,
                show: newWaitCount > 0
            };
        }
    }
    return state;
};

export default loaderReducer;
